/** Real contact email */
export const CONTACT_EMAIL = "jayamaha.cj@gmail.com";

export const CONTACT_WHATSAPP_DISPLAY = "+351 926 214 888";

export const CONTACT_WHATSAPP_URL = "https://wa.me/351926214888";

export const CONTACT_METHODS = [
  {
    key: "email",
    label: "EMAIL",
    value: CONTACT_EMAIL,
    sub: "Best for commissions, prints & collaborations.",
    href: `mailto:${CONTACT_EMAIL}`,
    external: false,
  },
  {
    key: "whatsapp",
    label: "WHATSAPP",
    value: CONTACT_WHATSAPP_DISPLAY,
    sub: "For a quick message or to say hello.",
    href: CONTACT_WHATSAPP_URL,
    external: true,
  },
];

export const CONTACT_SOCIAL = [
  { key: "instagram", label: "INSTAGRAM", href: "https://www.instagram.com/cjmeisterphotos/" },
  { key: "youtube", label: "YOUTUBE", href: "https://www.youtube.com/@cj.photos" },
  { key: "facebook", label: "FACEBOOK", href: "https://www.facebook.com/cjmeisterphotography" },
  { key: "linkedin", label: "LINKEDIN", href: "https://www.linkedin.com/in/cjmeister/" },
];
